import React, { useState, useEffect } from 'react';
import Trash from '../../../icons/trash';
import { generateJurisprudenceTitle } from '../../hooks/useTitleJurisprudence';
import { apiClient } from '../../../../utils/apiClient';

interface JurisprudencePopoverProps {
  referenceId: string;
  referenceText: string;
  onRemove: () => void;
  position: { top: number; left: number };
}

const JurisprudencePopover: React.FC<JurisprudencePopoverProps> = ({
  referenceId,
  referenceText,
  onRemove,
  position
}) => {
  const [title, setTitle] = useState<string>(referenceText);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchJurisprudenceData = async () => {
      if (!referenceId) {
        setTitle(referenceText);
        setIsLoading(false);
        return;
      }

      try {
        const response = await apiClient(`/jurisprudences/decision?id=${referenceId}`);

        if (!response.ok) {
          throw new Error('Failed to fetch jurisprudence data');
        }

        const decisionData = await response.json();

        const formattedTitle = generateJurisprudenceTitle(
          decisionData.jurisdiction || '',
          decisionData.location || '',
          decisionData.number || '',
          decisionData.decision_date || '',
          decisionData.chamber
        );

        setTitle(formattedTitle);
      } catch (error) {
        console.error('Error fetching jurisprudence data:', error);
        setTitle(referenceText); // Fallback to original text
      } finally {
        setIsLoading(false);
      }
    };

    fetchJurisprudenceData();
  }, [referenceId, referenceText]);

  return (
    <div
      className="absolute z-50 bg-mcdm-primary-100 dark:bg-mcdm-primary-100 border border-gray-300 rounded shadow-md p-2 min-w-[200px]"
      style={{ top: `${position.top}px`, left: `${position.left}px` }}
    >
      <p className="mb-2 text-sm text-mcdm-third-500">
        <strong>Jurisprudence :</strong>{' '}
        {isLoading ? (
          <span className="italic">Chargement...</span>
        ) : (
          title
        )}
      </p>
      <button
        onClick={onRemove}
        className="flex items-center gap-2 bg-red-500 hover:bg-red-600 text-white text-sm py-1 px-2 rounded"
      >
        <Trash width="14px" height="14px" fill="white" />
        Supprimer la référence
      </button>
    </div>
  );
};

export default JurisprudencePopover;
